import { Flex, Tag, Tooltip, Typography } from '@project44/manifest-ds';

const styles = {
  tag: {
    backgroundColor: '$palette-indigo-50',
    color: '$palette-indigo-800',
    flex: 1,
  },
  text: {
    flex: 3.5,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};

interface IHoverableLabel {
  text: string;
  label: string;
  labelTooltip: string;
}

function HoverableLabel({ text, label, labelTooltip }: IHoverableLabel) {
  return (
    <Flex align="center" gap="small" css={{ pointerEvents: 'none' }}>
      <Tooltip title={labelTooltip}>
        <Tag css={styles.tag}>{label}</Tag>
      </Tooltip>
      <Tooltip title={text}>
        <Typography variant="subtextBold" css={styles.text}>
          {text}
        </Typography>
      </Tooltip>
    </Flex>
  );
}

export default HoverableLabel;
